<svg:circle [attr.cx]="75" [attr.cy]="50" fill="#5699d2" r="5">
    <svg:animate
        attributeName="r"
        values="3;3;5;3;3"
        times="0;0.1;0.2;0.3;1"
        dur="1s"
        repeatCount="indefinite"
        [attr.begin]="begin"
    ></svg:animate>
    <svg:animate
        attributeName="fill"
        values="#5699d2;#5699d2;#1d3f72;#5699d2;#5699d2"
        repeatCount="indefinite"
        times="0;0.1;0.2;0.3;1"
        dur="1s"
        [attr.begin]="begin"
    ></svg:animate>
</svg:circle>
